import { render } from "./DeleteBudgetEntryConfirmationModal.vue?vue&type=template&id=0c55c864&ts=true"
import script from "./DeleteBudgetEntryConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteBudgetEntryConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__